import PropTypes from 'prop-types';
// @mui
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';

// ----------------------------------------------------------------------

export default function ShopSwitchDialog({ open, onClose, shops, currentShopId, onChangeShop }) {
    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
            <DialogTitle>Select Shop</DialogTitle>
            <DialogContent sx={{ pb: 3 }}>
                <Grid container spacing={2}>
                    {shops.map((shop) => (
                        <Grid item xs={12} sm={6} md={4} key={shop.id}>
                            <Card
                                sx={{
                                    border: (theme) => `solid 1px ${String(shop.id) === String(currentShopId) ? theme.palette.primary.main : theme.palette.divider}`,
                                    bgcolor: (theme) => String(shop.id) === String(currentShopId) ? 'action.selected' : 'background.paper',
                                }}
                            >
                                <CardActionArea
                                    onClick={() => onChangeShop(shop.id)}
                                    sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                                >
                                    <Avatar
                                        alt={shop.name}
                                        src={shop.avatar || ''}
                                        sx={{ width: 48, height: 48, mr: 2 }}
                                    >
                                        {shop.name.charAt(0).toUpperCase()}
                                    </Avatar>

                                    <ListItemText
                                        primary={shop.name}
                                        secondary={shop.category || 'No category'}
                                        primaryTypographyProps={{ typography: 'subtitle1', noWrap: true }}
                                        secondaryTypographyProps={{ typography: 'body2', noWrap: true, color: 'text.secondary' }}
                                    />
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

ShopSwitchDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    shops: PropTypes.array,
    currentShopId: PropTypes.string,
    onChangeShop: PropTypes.func,
};
